import { render, staticRenderFns } from "./AppNavigationHeaderViewMenu.vue?vue&type=template&id=08467b8c"
import script from "./AppNavigationHeaderViewMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppNavigationHeaderViewMenu.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports